import DeleteWidgetHostConfigRequestModelBase from '../_generated/modelBases/delete-widget-host-config-request-model-base';

export default class DeleteWidgetHostConfigRequestModel extends DeleteWidgetHostConfigRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
